import { Component } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, Router } from '@angular/router';
import { AktuelleFirmaUndStandortDto } from '@app/dto/aktuelleFirmaUndStandort.dto';
import { FirmaHistoryEintragDto } from '@app/dto/firma.history.eintrag.dto';
import { FirmenstandortHistoryEintragDto } from '@app/dto/firmenstandort.history.eintrag.dto';
import { HistoryEintragDto } from '@app/dto/history.eintrag.dto';
import { PcAdresseHistoryEintragDto } from '@app/dto/pcadresse.history.eintrag.dto';
import { TransactionDto } from '@app/dto/transaction.dto';
import { FirmenService } from '@app/services/firmen.service';
import { FirmenstandorteService } from '@app/services/firmenstandorte.service';
import { HistoryTableElement } from './history.table.element.model';
import { PcAdresseHistoryTableElement } from './pcadresse.history.table.element.model';
import { expandableRowAnimation } from "../firmen/expandable-row.animation";

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  animations: [expandableRowAnimation]
})
export class HistoryComponent {

  previousPage: string;
  firmenId: number;
  firmenstandorteId: number;

  firmaDatasource!: MatTableDataSource<AktuelleFirmaUndStandortDto>;
  firmaHistoryDatasource!: HistoryTableElement[];
  firmenstandorteHistoryDatasource!: HistoryTableElement[];
  pcAdressenHistoryTableDatasource!: PcAdresseHistoryTableElement[];

  displayFirmaDataColumns: string[] = ['firmenId', 'firmenname', 'anschrift', 'crefonummer', 'beDirectId'];

  displayColumns: string[] = ['expand', 'title',];

  // displayColumnsTransaction: string[] = [
  //   'datum',
  //   'uhrzeit',
  //   'id',
  //   'aktion',
  //   'kommentar',
  //   'user',
  // ];

  initColumnsTransaction = [
    {
      name: 'datum',
      label: 'Datum',
    },
    {
      name: 'uhrzeit',
      label: 'Uhrzeit',
    },
    {
      name: 'id',
      label: 'ID',
    },
    {
      name: 'aktion',
      label: 'Aktion',
    },
    {
      name: 'kommentar',
      label: 'Kommentar',
    },
    {
      name: 'user',
      label: 'User',
    },
  ];

  displayColumnsTransaction = this.initColumnsTransaction.map(col => col.name);

  displayColumnsTransactionWithAction: string[] = ['expand', ...this.displayColumnsTransaction,];

  initColumnsFirmaHistoryEintraege = [
    {
      name: 'status',
      label: 'Status',
    },
    {
      name: 'firmenId',
      label: 'Firmen-ID',
    },
    {
      name: 'firmenname',
      label: 'Name',
    },
    {
      name: 'crefonummer',
      label: 'Crefonummer',
    },
    {
      name: 'branchencodeWz2008',
      label: 'Branchencode Wz 2008',
    },
    {
      name: 'branchencodeWz1979',
      label: 'Branchencode Wz 1979',
    },
    {
      name: 'lieferantVonBranche',
      label: 'lieferant Von Branche',
    },
    {
      name: 'branchenzuschlag',
      label: 'Branchenzuschlag',
    },
    {
      name: 'psKundenstatus',
      label: 'PS Kundenstatus',
    },
    {
      name: 'psLieferantenstatus',
      label: 'PS Lieferantenstatus',
    },
    {
      name: 'isdKundenstatus',
      label: 'ISD Kundenstatus',
    },
    {
      name: 'isdLieferantenstatus',
      label: 'ISD Lieferantenstatus',
    },
    {
      name: 'istArbeitsagentur',
      label: 'ist Arbeitsagentur',
    },
    {
      name: 'istWettbewerber',
      label: 'ist Wettbewerber',
    },
    {
      name: 'waehrungscode',
      label: 'währung',
    },
    {
      name: 'webseiteHomepage',
      label: 'webseite Homepage',
    },
    {
      name: 'webseiteJobboerse',
      label: 'webseite Jobbörse',
    },
    {
      name: 'istGeloescht',
      label: 'ist Geloescht',
    },
  ];

  displayColumnsFirmaHistoryEintraege = this.initColumnsFirmaHistoryEintraege.map(col => col.name);

  initColumnsFirmenstandortHistoryEintraege = [
    {
      name: 'status',
      label: 'status',
    },
    {
      name: 'id',
      label: 'Firmenstandorte-ID',
    },
    {
      name: 'salesforceId',
      label: 'salesforceId',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'laendercode',
      label: 'Land',
    },
    {
      name: 'telefon',
      label: 'telefon',
    },
    {
      name: 'fax',
      label: 'fax',
    },
    {
      name: 'postfach',
      label: 'postfach',
    },
    {
      name: 'email',
      label: 'email',
    },
    {
      name: 'betriebsgroesse',
      label: 'betriebsgroesse',
    },
    {
      name: 'betriebsgroesseGewerblich',
      label: 'betriebsgroesse Gewerblich',
    },
    {
      name: 'betriebsgroesseKaufmaennisch',
      label: 'betriebsgroesse Kaufmännisch',
    },
    {
      name: 'hatKantine',
      label: 'hat Kantine',
    },
    {
      name: 'psStatusCode',
      label: 'PS Status Code',
    },
    {
      name: 'isdStatusCode',
      label: 'ISD Status Code',
    },
    {
      name: 'beDirectId',
      label: 'Bedirect-ID',
    },
    {
      name: 'istFirmenhauptstandort',
      label: 'ist Firmenhauptstandort',
    },
    {
      name: 'firmenId',
      label: 'Firmen-ID',
    },
    {
      name: 'istGeloescht',
      label: 'ist Geloescht',
    },
  ]

  displayColumnsFirmenstandortHistoryEintraege = this.initColumnsFirmenstandortHistoryEintraege.map(col => col.name);

  initColumnsPcAdressenHistoryEintraege = [
    {
      name: 'status',
      label: 'status',
    },
    {
      name: 'firmenstandorteId',
      label: 'firmenstandorte-ID',
    },
    {
      name: 'crefonummer',
      label: 'Crefonummer',
    },
    {
      name: 'firmenId',
      label: 'firmen-ID',
    },
    {
      name: 'firmenName',
      label: 'Name',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'laenderCode',
      label: 'Land',
    },
  ]

  displayColumnsPcAdressenHistoryEintraege = this.initColumnsPcAdressenHistoryEintraege.map(col => col.name);

  expandedFirmaTransaction!: TransactionDto | null;
  expandedFirmaHistory!: FirmaHistoryEintragDto | null;
  expandedFirmenstandortTransactions!: TransactionDto | null;
  expandedFirmenstandortHistory!: FirmenstandortHistoryEintragDto | null
  expandedPcAdresseTable!: HistoryTableElement | null;
  expandedPcAdresseTransactions!: TransactionDto | null;
  expandedPcAdresseHistory!: PcAdresseHistoryEintragDto | null;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private firmenService: FirmenService,
    private firmenstandorteService: FirmenstandorteService,

  ) {
    this.previousPage = this.route.snapshot.url[0].path;
    this.firmenId = Number(this.route.snapshot.url[1].path);
    this.firmenstandorteId = Number(this.route.snapshot.url[3].path);

    this.firmenService.getFirmaHistory(this.firmenId, this.firmenstandorteId, 50, 0)
      .subscribe(response => {
        let firmaData: AktuelleFirmaUndStandortDto[] = [response.aktuelleFirmaUndStandort];
        this.firmaDatasource = new MatTableDataSource(firmaData);

        let firmaHistoryTableElementList: HistoryTableElement[] = [];

        if (response.transaktionen) {
          let transactionsFirmaList: TransactionDto[] = [];
          response.transaktionen.forEach(transaction => {

            let transactionDto: TransactionDto = {
              uhrzeit: transaction.ausgefuehrtAm,
              datum: transaction.ausgefuehrtAm,
              transactionId: transaction.id,
              aktion: transaction.ausgefuehrteAktionen.replace(/\. /g, '\.\n'),
              user: transaction.ausgefuehrtVon,
              kommentar: transaction.kommentar
            }

            let firmaHistoryEintraegeList: HistoryEintragDto[] = [];

            if (transaction.eintragAlt != undefined && transaction.eintragAlt != null) {
              firmaHistoryEintraegeList.push({ status: 'Alt', ...transaction.eintragAlt });
            }

            if (transaction.eintragNeu != undefined && transaction.eintragNeu != null) {
              firmaHistoryEintraegeList.push({ status: 'Neu', ...transaction.eintragNeu });
            }

            transactionDto.firmaHistoryEintraege = new MatTableDataSource(firmaHistoryEintraegeList);

            transactionsFirmaList.push(transactionDto);
          });

          let firmaHistoryTableElement: HistoryTableElement = {
            title: ' Änderungen der Stammdaten der Firma',
            transactions: new MatTableDataSource(transactionsFirmaList)
          }

          firmaHistoryTableElementList.push(firmaHistoryTableElement)

          this.firmaHistoryDatasource = firmaHistoryTableElementList;

          let firmenstandortHistoryTableElementList: HistoryTableElement[] = [{
            title: ' Änderungen der Stammdaten eines Firmenstandortes',
            transactions: new MatTableDataSource(),
          }];

          this.firmenstandorteHistoryDatasource = firmenstandortHistoryTableElementList;

          let pcAdresseHistoryTableElementList: PcAdresseHistoryTableElement[] = [{
            title: ' Änderungen der Zuordnung der PcAdressen',
            tableElements: new MatTableDataSource(),
          }];

          this.pcAdressenHistoryTableDatasource = pcAdresseHistoryTableElementList;
        }
      });
  }

  back() {
    this.router.navigate([`firma/${this.firmenId}`]);
  }

  toggleRowFirmaTransactions(element: TransactionDto) {
    this.expandedFirmaTransaction = this.expandedFirmaTransaction === element ? null : element;
  }

  toggleRowFirmaHistory(element: FirmaHistoryEintragDto) {
    this.expandedFirmaHistory = this.expandedFirmaHistory === element ? null : element;
  }

  loadFirmenstandorteHistory(element: TransactionDto) {
    this.firmenstandorteService.getFirmenstandortHistory(this.firmenstandorteId, 50, 0)
      .subscribe(response => {
        if (response.transaktionen) {
          let transactionsFirmenstandortList: TransactionDto[] = [];
          response.transaktionen.forEach(transaction => {

            let transactionDto: TransactionDto = {
              uhrzeit: transaction.ausgefuehrtAm,
              datum: transaction.ausgefuehrtAm,
              transactionId: transaction.id,
              aktion: transaction.ausgefuehrteAktionen.replace(/\. /g, '\.\n'),
              user: transaction.ausgefuehrtVon,
              kommentar: transaction.kommentar,
            }

            let firmenstandortHistoryEintraegeList: FirmenstandortHistoryEintragDto[] = [];

            if (transaction.eintragAlt != undefined && transaction.eintragAlt != null) {
              transaction.eintragAlt.status = 'Alt';
              firmenstandortHistoryEintraegeList.push(transaction.eintragAlt);
            }

            if (transaction.eintragNeu != undefined && transaction.eintragNeu != null) {
              transaction.eintragNeu.status = 'Neu';
              firmenstandortHistoryEintraegeList.push(transaction.eintragNeu);
            }

            transactionDto.firmenstandortHistoryEintraege = new MatTableDataSource(firmenstandortHistoryEintraegeList);

            transactionsFirmenstandortList.push(transactionDto);
          });

          this.firmenstandorteHistoryDatasource[0].transactions = new MatTableDataSource(transactionsFirmenstandortList);

          this.expandedFirmenstandortTransactions = this.expandedFirmenstandortTransactions === element ? null : element;

        }
      });
  }

  toggleRowFirmenstandortHistory(element: FirmenstandortHistoryEintragDto) {
    this.expandedFirmenstandortHistory = this.expandedFirmenstandortHistory === element ? null : element;
  }

  loadPcAdressenHistory(element: HistoryTableElement) {
    this.firmenstandorteService.getPcAdressenHistory(this.firmenstandorteId, 50, 0)
      .subscribe(response => {
        if (response) {
          let pcAdresseHistoryList: HistoryTableElement[] = [];

          response.forEach(pcAdresseHistoryElement => {
            let transactionsPcAdressenList: TransactionDto[] = [];
            pcAdresseHistoryElement.transaktionen.forEach(transaction => {

              let transactionDto: TransactionDto = {
                uhrzeit: transaction.ausgefuehrtAm,
                datum: transaction.ausgefuehrtAm,
                transactionId: transaction.id,
                aktion: transaction.ausgefuehrteAktionen.replace(/\. /g, '\.\n'),
                user: transaction.ausgefuehrtVon,
                kommentar: transaction.kommentar,
              }

              let pcAdresseHistoryEintraegeList: PcAdresseHistoryEintragDto[] = [];

              if (transaction.eintragAlt != undefined && transaction.eintragAlt != null) {
                transaction.eintragAlt.status = 'Alt';
                pcAdresseHistoryEintraegeList.push(transaction.eintragAlt);
              }

              if (transaction.eintragNeu != undefined && transaction.eintragNeu != null) {
                transaction.eintragNeu.status = 'Neu';
                pcAdresseHistoryEintraegeList.push(transaction.eintragNeu);
              }

              transactionDto.pcAdressenHistoryEintraege = new MatTableDataSource(pcAdresseHistoryEintraegeList);
              transactionsPcAdressenList.push(transactionDto);

            });
            pcAdresseHistoryList.push({
              title: `PCADRESSE ${pcAdresseHistoryElement.aktuellePcAdresse.pcAdressenId} | 
                ORIGINAL POSTANSCHRIFT ${pcAdresseHistoryElement.aktuellePcAdresse.originalPostanschrift} | 
                ORIGINAL FIRMENNAME ${pcAdresseHistoryElement.aktuellePcAdresse.originalFirmenname}`,
              transactions: new MatTableDataSource(transactionsPcAdressenList)
            });
          });

          this.pcAdressenHistoryTableDatasource[0].tableElements = new MatTableDataSource(pcAdresseHistoryList);
          this.expandedPcAdresseTable = this.expandedPcAdresseTable === element ? null : element;

        }
      });
  }

  toggleRowPcAdresseTransaction(element: TransactionDto) {
    this.expandedPcAdresseTransactions = this.expandedPcAdresseTransactions === element ? null : element;
  }

  toggleRowPcAdresseHistory(element: PcAdresseHistoryEintragDto) {
    this.expandedPcAdresseHistory = this.expandedPcAdresseHistory === element ? null : element;
  }
}
